module.exports = __webpack_public_path__ + "img/system_structure.94423e5d.png";